import { useEffect } from 'react';
import { usePracticeOutbox } from '../api/use-practice-outbox.js';

/** Sends what the phone is holding when the app opens and when signal returns. */
export function PracticeOutboxSender() {
  const outbox = usePracticeOutbox();
  useEffect(() => {
    const send = () => void outbox.flush();
    send();
    window.addEventListener('online', send);
    return () => window.removeEventListener('online', send);
  }, [outbox]);
  return null;
}
